import { useTranslations } from "next-intl";
import { ButtonHTMLAttributes } from "react";
import SearchIcon from "../../icons/SearchIcon";
import "./index.scss";

const SearchButton = ({
  children,
  id = "",
  className = "",
  ...remainingProps
}: ButtonHTMLAttributes<HTMLButtonElement>) => {
  const t = useTranslations("CheckAvailability");

  return (
    <button
      id={id}
      className={`component search-button ${className}`}
      {...remainingProps}
    >
      <SearchIcon />
      <span className="button-label">{t("search")}</span>
    </button>
  );
};

export default SearchButton;
